import { useSearchParams } from 'react-router-dom';

import { SettingLayout } from '@/components/setting/SettingLayout';
import GroupListPage from '@/components/setting/groups/GroupListPage';
import GroupDetailPage from '@/components/setting/groups/GroupDetailPage';

export default function Groups() {
  const [searchParams] = useSearchParams();

  const groupId = searchParams.get('id') ?? '';

  return <SettingLayout>{groupId === '' ? <GroupListPage /> : <GroupDetailPage />}</SettingLayout>;
}
